import { SessionContext } from '../../context/session-context'
import { useContext } from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const TopNavigation = (): React.ReactElement => {
  const { isLoggedIn } = useContext(SessionContext)

  return !isLoggedIn ? (
    <></>
  ) : (
    <Navbar>
      <Container fluid>
        <Navbar.Brand href={window.location.origin}>GRNDHOUSE</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link as={Link} to="/logout">
              Log out
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
